import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * MetaPixelTracker
 * Invia PageView a Meta e page_view a GA4 ad ogni cambio di route
 * (indispensabile su SPA React, poiché gli snippet in <head>
 * vengono eseguiti una sola volta all'avvio).
 */
export default function MetaPixelTracker() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    if (typeof window === "undefined") return;

    // Meta Pixel — salta il primo PageView (già inviato dallo snippet in index.html)
    if (typeof window.fbq === "function") {
      if (window.__fbqFirstLoad !== true) {
        window.__fbqFirstLoad = true;
      } else {
        window.fbq("track", "PageView");
      }
    }

    // GA4 — salta la prima page_view (già inviata da gtag config in index.html)
    if (typeof window.gtag === "function") {
      if (window.__gaFirstLoad !== true) {
        window.__gaFirstLoad = true;
      } else {
        window.gtag("event", "page_view", {
          page_path: pathname + search,
          page_location: window.location.href,
        });
      }
    }
  }, [pathname, search]);

  return null;
}
